import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { CardActionDirective } from 'common/directives/card-action.directive';
import { CheckoutCardAction, CheckoutCardActionPayload, CheckoutCardActionType } from 'user/models/checkouts';
import { UserReceiptActionStatus } from 'user/models/user-receipt-card';

@Component({
  selector: 'app-checkout-card-action-button',
  templateUrl: './checkout-card-action-button.component.html',
  styleUrls: ['./checkout-card-action-button.component.scss'],
})
export class CheckoutCardActionButtonComponent {
  @Input() public action: CheckoutCardAction | null = null;
  @Input() public disabled: boolean;
  @Input() public ariaDescribedBy = '';
  @Output() public triggerAction = new EventEmitter<CheckoutCardActionPayload>();

  public cardActions: CardActionDirective[];
  public actionDropdownOpened: boolean;
  public defaultAction: CardActionDirective;
  public readonly actionStatus = UserReceiptActionStatus;
  public readonly actionType = CheckoutCardActionType;

  @ContentChildren(CardActionDirective)
  public set cardActionsList(actions: QueryList<CardActionDirective>) {
    this.cardActions = actions.toArray();

    if (this.cardActions.length) {
      this.defaultAction = this.cardActions.shift();
    }
  }

  public setDropdownOpened(opened: boolean) {
    this.actionDropdownOpened = opened;
  }

  public toggleDropdown(dropdown: NgbDropdown): void {
    if (!this.disabled && !this.actionDropdownOpened) {
      dropdown.open();
    } else {
      dropdown.close();
    }
  }

  public onTriggerAction(action: CardActionDirective): void {
    this.triggerAction.emit({
      actionType: action.cardAction,
      payload: action.cardActionPayload,
    });
  }
}
